/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import Typography from '../../base/Typography';
import { Row, Col } from '../../base/Grid';
import ArrowRightIcon from '../../icons/utility/ArrowRight';

const getComponentVariantBgColor = (theme, bgVariant) => {
  if (bgVariant === 'primary') {
    return theme.colors.neutral.white;
  }
  return theme.colors.neutral.gray99;
};

export const DivProductCalloutCardStyled = styled.div`
  ${({ theme, bgVariant, condensed }) => css`
    position: relative;
    background-color: ${getComponentVariantBgColor(theme, bgVariant)};
    color: ${theme.colors.neutral.gray29};
    height: 100%;
    ${condensed ? `padding: ${rem(24)} 0;` : `padding: ${rem(40)} 0;`} :hover {
      .icon-product-callout-arrow {
        transition: margin 0.2s;
        margin-left: ${rem(15)};
      }
    }
  `}
`;

export const ProductCalloutRow = styled(Row)`
  ${({ condensed }) => css`
    position: relative;
    padding: 0 ${rem(16)};
    ${condensed && 'display:none;'}
  `}
`;

export const ProductCalloutButtonCol = styled(Col)`
  padding-right: 0;
`;

export const RowHeaderStyled = styled(Row)`
  justify-content: space-between;
  align-items: flex-start;
`;

export const TypographyHeaderStyled = styled(Typography)`
  ${({ theme, condensed, withHeaderAccent }) => {
    const mediumUp = theme.mediumUp();
    const largeUp = theme.largeUp();
    let height = rem(23);
    let maxWidth = '85%';
    let paddingBottom = mediumUp ? rem(12) : rem(8);
    let decorationDisplay = 'none';

    if (largeUp) {
      height = rem(28);
      maxWidth = '80%';
    } else if (mediumUp) {
      height = rem(25);
      maxWidth = '75%';
    }

    if (condensed) {
      paddingBottom = 0;
      decorationDisplay = 'inline-block';
      maxWidth = '100%';
    }
    if (withHeaderAccent) {
      decorationDisplay = 'inline-block';
    }

    return css`
      padding-bottom: ${paddingBottom};
      max-width: ${maxWidth};
      :before {
        content: '';
        position: absolute;
        left: 0;
        display: ${decorationDisplay};
        width: ${rem(5)};
        height: ${height};
        background-color: ${theme.colors.cta.yellow};
      }
    `;
  }}
`;

export const TypographyCardCopyStyled = styled(Typography)`
  padding-bottom: 0;
  padding-right: ${rem(52)};
`;

export const IconCardTitleStyled = styled(ArrowRightIcon)`
  transition: margin 0.2s;
  margin-bottom: ${rem(2)};
  margin-left: ${rem(10)};
`;

export const ColLinkContainerStyled = styled(Col)`
  margin-top: ${rem(24)};
`;

export const ButtonCondensedCardOverlayStyled = styled.button`
  width: 100%;
  height: 100%;
  opacity: 0;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
`;

/** Creates inline styles (to override stock Component Library styles) */
export const Styles = () => ({
  IconCardMainStyled: {
    height: rem(44),
    width: rem(44),
    position: 'absolute',
    right: '1rem',
    top: '-.5rem',
  },
});
